import { render } from "./AddInternalNoteForm.vue?vue&type=template&id=13a6c982&scoped=true"
import script from "./AddInternalNoteForm.vue?vue&type=script&lang=js"
export * from "./AddInternalNoteForm.vue?vue&type=script&lang=js"

import "./AddInternalNoteForm.vue?vue&type=style&index=0&id=13a6c982&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a6c982"]])

export default __exports__